import addRequestHeaders from './addRequestHeaders.js';

function addForceTraceHeader(forceTrace) {
    return addRequestHeaders(function () {
        var forceTraceValue = forceTrace && forceTrace();
        if (forceTraceValue) {
            return { 'X-Deal-Force-Trace': forceTraceValue };
        }
        else {
            return {};
        }
    });
}

export default addForceTraceHeader;
//# sourceMappingURL=forceTrace.js.map
